import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { HttpService } from '../http.service';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-customerwisedetailsreport',
  templateUrl: './customerwisedetailsreport.component.html',
  styleUrls: ['./customerwisedetailsreport.component.scss']
})
export class CustomerwisedetailsreportComponent implements OnInit {

  selected_from_date: any = null;
  selected_to_date: any = null;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.selected_from_date,
      'to_date': this.selected_to_date,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.copm2Areport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      console.error(error);
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const excel_file_name = this.document_file['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = excel_file_name;
    downloadLink.click();
  }


  downloadClickedpdf() {
    console.info('aaaa',)
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const pdf_file_name = this.document_file['pdf_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = pdf_file_name;
    downloadLink.click();
  }

  // Function to handle date change event
  changeEvent() {

  }



  ngOnInit() {
  }


}
